/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { MediaDownloadRequestToJSON, MediaDownloadResponseFromJSON, MediaVersionsResponseFromJSON, OperationToJSON, UserFileFromJSON, UserFileToJSON, UserFileEntityCursorPageResponseFromJSON, } from '../models/index';
/**
 *
 */
export class AdminUserFilesApi extends runtime.BaseAPI {
    /**
     */
    adminUserFilesCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/admin/user-files`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: UserFileToJSON(requestParameters.userFile),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserFileFromJSON(jsonValue));
        });
    }
    /**
     */
    adminUserFilesCreate(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.adminUserFilesCreateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    adminUserFilesCreateDownloadUrlByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling adminUserFilesCreateDownloadUrlById.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/admin/user-files/{id}/download-url`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: MediaDownloadRequestToJSON(requestParameters.mediaDownloadRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => MediaDownloadResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    adminUserFilesCreateDownloadUrlById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.adminUserFilesCreateDownloadUrlByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    adminUserFilesDeleteByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling adminUserFilesDeleteById.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/admin/user-files/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    adminUserFilesDeleteById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.adminUserFilesDeleteByIdRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    adminUserFilesGetByIdByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling adminUserFilesGetByIdById.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/admin/user-files/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserFileFromJSON(jsonValue));
        });
    }
    /**
     */
    adminUserFilesGetByIdById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.adminUserFilesGetByIdByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    adminUserFilesListVersionsByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling adminUserFilesListVersionsById.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/admin/user-files/{id}/versions`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => MediaVersionsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    adminUserFilesListVersionsById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.adminUserFilesListVersionsByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    adminUserFilesPaginateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.search !== undefined) {
                queryParameters['search'] = requestParameters.search;
            }
            if (requestParameters.sort !== undefined) {
                queryParameters['sort'] = requestParameters.sort;
            }
            if (requestParameters.filters !== undefined) {
                queryParameters['filters'] = requestParameters.filters;
            }
            if (requestParameters.page !== undefined) {
                queryParameters['page'] = requestParameters.page;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['pageSize'] = requestParameters.pageSize;
            }
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/admin/user-files`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserFileEntityCursorPageResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    adminUserFilesPaginate(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.adminUserFilesPaginateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    adminUserFilesReprocessFileByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling adminUserFilesReprocessFileById.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/admin/user-files/{id}/reprocess`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    adminUserFilesReprocessFileById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.adminUserFilesReprocessFileByIdRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    adminUserFilesUpdateByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling adminUserFilesUpdateById.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/admin/user-files/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.operation.map(OperationToJSON),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserFileFromJSON(jsonValue));
        });
    }
    /**
     */
    adminUserFilesUpdateById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.adminUserFilesUpdateByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
